module.exports = __webpack_public_path__ + "static/right-tree-ae1ce7540e53ab76f65c8dcf99233fef.png";